<template>
    <div class="float-left mr-1">
        <span class="text-danger">
            <i
                class="fa fa-trash fa-lg icon-button"
                title="Excluir Penalidade"
                @click.stop="confirmarExcluir()"
            ></i>
        </span>
    </div>
</template>

<script>
import PenalidadesServicos from './PenalidadesServicos'

export default {
    props: {
        contrato: {
            type: Object,
            default: () => ({})
        },

        penalidade: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarExcluir() {
            this.$swal({
                title: 'Penalidade do Contrato',
                html: `Confirma a exclusão da penalidade do tipo ${this.penalidade.tipoPenalidade}?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.excluir()
                }
            })
        },

        excluir() {
            this.$store.dispatch('addRequest')
            let penalidadeDto = {
                contratoId: this.contrato.idContrato,
                penalidadeId: this.penalidade.penalidadeId
            }
            PenalidadesServicos.excluir(penalidadeDto).then(response => {
                if (response) {
                    if (response.success) {
                        this.registroSalvoComSucesso()
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        registroSalvoComSucesso() {
            this.$toast.success(
                'Registro excluído com sucesso!',
                'OK',
                this.$toastConfig.success
            )
            this.$emit('obterPenalidadesAtualizadas')
        }
    },

    created() {},

    computed: {},

    watch: {},

    validations: {}
}
</script>
